export default [
    {
        path: '/lock-screen',
        name: 'page-lock-screen',
        component: () => import('@/views/LockScreen.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/comingsoon',
        name: 'page-coming-soon',
        component: () => import('@/views/ComingSoon.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/error-404',
        name: 'page-error-404',
        component: () => import('@/views/Error404.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/error-500',
        name: 'page-error-500',
        component: () => import('@/views/Error500.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/not-authorized',
        name: 'page-not-authorized',
        component: () => import('@/views/NotAuthorized.vue'),
        meta: {
            rule: 'editor'
        }
    },
    {
        path: '/maintenance',
        name: 'page-maintenance',
        component: () => import('@/views/Maintenance.vue'),
        meta: {
            rule: 'editor'
        }
    }
]